import smartSolveApi from './instances/smartsolve';

export const saveDocumentRepositoryConfig = async (params) => {
  try {
    const response = await smartSolveApi.post('/documentrepositoryconfig/save', params);

    return response.data;
  } catch (e) {
    throw new Error(`saveDocumentRepositoryConfig() failed: ${e}`);
  }
};

export const saveDocumentRepositoryConfigFromTemplate = async (params) => {
  try {
    const response = await smartSolveApi.post('documentrepositoryconfig/savefromtemplate', params);

    return response.data;
  } catch (e) {
    throw new Error(`saveDocumentRepositoryConfigFromTemplate() failed: ${e}`);
  }
};

export const publishDocumentRepositoryConfig = async (params) => {
  try {
    const response = await smartSolveApi.post('documentrepositoryconfig/publish', params);

    return response.data;
  } catch (e) {
    throw new Error(`publishDocumentRepositoryConfig() failed: ${e}`);
  }
};

export const unpublishDocumentRepositoryConfig = async (params) => {
  try {
    const response = await smartSolveApi.post('/documentrepositoryconfig/unpublish', params);

    return response.data;
  } catch (e) {
    throw new Error(`unpublishDocumentRepositoryConfig() failed: ${e}`);
  }
};

export const deleteDocumentRepositoryConfig = async (params) => {
  try {
    const response = await smartSolveApi.post('/documentrepositoryconfig/delete', params);

    return response.data;
  } catch (e) {
    throw new Error(`deleteDocumentRepositoryConfig() failed: ${e}`);
  }
};

export const checkRepositoryName = async (params) => {
  try {
    const response = await smartSolveApi.post('/documentrepositoryconfig/checkname', params);

    return response.data;
  } catch (e) {
    throw new Error(`checkRepositoryName() failed: ${e}`);
  }
};

export const getDocumentRepositoryConfig = async ({ repositoryId }) => {
  try {
    const response = await smartSolveApi.post('/documentrepositoryconfig/get', { repositoryId });

    return response.data;
  } catch (e) {
    throw new Error(`getDocumentRepositoryConfig() failed: ${e}`);
  }
};

export const saveDistribution = async (params) => {
  try {
    const response = await smartSolveApi.post('/documentrepositoryconfig/savedistribution', params);

    return response.data;
  } catch (e) {
    throw new Error(`saveDistribution() failed: ${e}`);
  }
};
